import { useState } from 'react'

import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import InputsWithoutValidate from 'Components/UI/Molecules/InputsWithoutValidate'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import { SUCURSAL_ORIGEN } from 'Constants'
import { interfaces } from 'service/interfaces'

import CheckList from './Cheque'
import { fieldsAddPaymentOrder } from './fields'

const AddItem = (props) => {
  const { data, open, handleClose, render, setRender, dataInfo, setRows, setData } = props
  const createDismissableSnackbar = useCustomSnackbar()
  const [checkElement, setCheckElement] = useState([])

  const [isLoading, setIsLoading] = useState(false)
  const [info, setInfo] = useState({
    empresa: dataInfo.infoMain.origen,
    recibo: dataInfo.receipt.id,
    tipo: null,
    importe: null,
    detalle: '',
    descripcion: '',
    origen: null,
    lote: null,
    cupon: null,
    nro_operacion: null,
    moneda: null,
    cotizacion: null,
    barcode: '',
    cheque: null,
    verificacion3: null,
  })

  const handleChange = (name, value) => {
    setInfo((prevInfo) => ({
      ...prevInfo,
      [name]: value,
    }))
  }

  const addProducts = async () => {
    if ((!info.tipo || !info.importe) && info.tipo !== 49 && info.tipo !== 50) {
      createDismissableSnackbar("Los campos 'Método de pago' e 'Importe' son obligatorios", {
        variant: 'error',
      })
      return
    }
    const chequesId = checkElement.map((item) => item.id)
    const origen = SUCURSAL_ORIGEN.find((sucursal) => sucursal.label === info.empresa)
    const values =
      info.tipo === 1
        ? {
            empresa: origen ? origen.id : null,
            orden: dataInfo.paymentOrder.id,
            tipo: info.tipo,
            importe: Number(info.importe),
            descripcion: info.descripcion,
            detalle: info.detalle,
          }
        : info.tipo === 4
          ? {
              empresa: origen ? origen.id : null,
              orden: dataInfo.paymentOrder.id,
              tipo: info.tipo,
              importe: Number(info.importe),
              descripcion: info.descripcion,
              detalle: info.detalle,
              cupon: info.nro_operacion ? Number(info.nro_operacion) : Number(info.cupon),
            }
          : info.tipo === 8
            ? {
                empresa: origen ? origen.id : null,
                orden: dataInfo.paymentOrder.id,
                tipo: info.tipo,
                importe: Number(info.importe),
                cupon: info.nro_operacion
                  ? Number(info.nro_operacion)
                  : info.cupon
                    ? Number(info.cupon)
                    : Number(info.cotizacion),
                moneda: info.moneda,
                descripcion: info.descripcion,
                detalle: info.detalle,
              }
            : info.tipo === 10
              ? {
                  empresa: origen ? origen.id : null,
                  orden: dataInfo.paymentOrder.id,
                  tipo: info.tipo,
                  importe: Number(info.importe),
                  origen: info.origen,
                  barcode: info.barcode,
                  descripcion: info.descripcion,
                  cupon: info.cheque,
                  detalle: info.detalle,
                }
              : info.tipo === 5
                ? {
                    empresa: origen ? origen.id : null,
                    orden: dataInfo.paymentOrder.id,
                    tipo: info.tipo,
                    importe: Number(info.importe),
                    detalle: info.detalle,
                    descripcion: info.descripcion,
                    barcode_cheque: info.cheque, //0113565500 4 11206530 3 56011061 8
                    cupon: 'm', //0140441744 1 25498120 5 05126513753 4
                  }
                : info.tipo === 6 || info.tipo === 7
                  ? {
                      empresa: origen ? origen.id : null,
                      orden: dataInfo.paymentOrder.id,
                      tipo: info.tipo,
                      importe: Number(info.importe),
                      descripcion: info.descripcion,
                      detalle: info.detalle,
                      origen: info.origen,
                      cupon: info.nro_operacion
                        ? Number(info.nro_operacion)
                        : info.cupon
                          ? Number(info.cupon)
                          : Number(info.cotizacion),
                    }
                  : info.tipo === 49
                    ? {
                        empresa: origen ? origen.id : null,
                        orden: dataInfo.paymentOrder.id,
                        tipo: info.tipo,
                        cheque_propio: chequesId,
                      }
                    : info.tipo === 50
                      ? {
                          empresa: origen ? origen.id : null,
                          orden: dataInfo.paymentOrder.id,
                          tipo: info.tipo,
                          cheque_tercero: chequesId,
                        }
                      : info.tipo === 51
                        ? {
                            empresa: origen ? origen.id : null,
                            orden: dataInfo.paymentOrder.id,
                            tipo: info.tipo,
                            importe: Number(info.importe),
                            origen: info.origen,
                            lote: 0,
                            descripcion: info.descripcion,
                          }
                        : {
                            empresa: origen ? origen.id : null,
                            orden: dataInfo.paymentOrder.id,
                            tipo: info.tipo,
                            importe: Number(info.importe),
                            descripcion: info.descripcion,
                            detalle: info.detalle,
                            origen: info.origen,
                            lote: info.lote,
                            cupon: info.nro_operacion
                              ? Number(info.nro_operacion)
                              : info.cupon
                                ? Number(info.cupon)
                                : Number(info.cotizacion),
                          }

    setIsLoading(true)
    await interfaces.salesOrders
      .addPaymentOrderDetail(values)
      .then((res) => {
        setRows((prevRows) => [...prevRows, { ...info, descripcion: values.descripcion }])
        setData((prevData) => ({
          ...prevData,
          paymentOrderDetails: [
            ...prevData.paymentOrderDetails,
            { ...info, descripcion: values.descripcion },
          ],
          paymentOrder: {
            ...prevData.paymentOrder,
            total: Math.trunc(prevData.paymentOrder.total || 0) + Math.trunc(Number(info.importe)),
            saldoResto:
              Math.trunc(prevData.paymentOrder.saldoResto || 0) - Math.trunc(Number(info.importe)),
          },
        }))

        setRender(!render)
        createDismissableSnackbar(res.data, {
          variant: 'success',
        })
      })
      .catch(() => {
        createDismissableSnackbar('Error', {
          variant: 'error',
        })
      })
    setIsLoading(false)
    handleClose()
  }

  function _renderStepContent() {
    return (
      <>
        <InputsWithoutValidate
          fields={fieldsAddPaymentOrder(info, handleChange, isLoading, data)}
          spacing={2}
        />
        {info.tipo === 49 || info.tipo === 50 ? (
          <div style={{ marginTop: '10px' }}>
            <CheckList
              addProducts={addProducts}
              checkElement={checkElement}
              setCheckElement={setCheckElement}
              type={info.tipo}
            />
          </div>
        ) : null}
      </>
    )
  }

  const isSubmitDisabled =
    info.tipo === 5 ? !(info.verificacion && [1,2,3,4,5,6,7,8,9,].includes(Number(info.verificacion3)))
    : info.tipo === 1 || info.tipo === 4 ? !info.importe
    : info.tipo === 2 ? !info.origen || !info.importe || !info.lote || !info.cupon 
    : info.tipo === 3 ? !info.origen || !info.importe || !info.lote || !info.cupon
    : info.tipo === 10 ? !info.cheque || !info.importe || !info.origen || !info.barcode
    : info.tipo === 6 || info.tipo === 7 ? !info.importe || !info.origen || !info.nro_operacion
    : info.tipo === 8 ? !info.importe || !info.moneda || !info.cotizacion
    : info.tipo === 51 ? !info.importe || info.retencion
    : true

  return (
    <DialogComponent
      title="Agregar método de pago"
      open={open}
      handleclose={handleClose}
      handleclosedisabled={isLoading}
      widthLarge="500px"
      disableBackdropClick
      disableEscapeKeyDown
      maxHeight
      children={
        <>
          <div>{_renderStepContent()}</div>
        </>
      }
      actions={
        <CancelConfirmButtons
          disabledSubmit={isLoading || isSubmitDisabled}
          disabledCancel={isLoading}
          isLoading={isLoading}
          onClickSubmit={addProducts}
          onClickCancel={handleClose}
        />
      }
    />
  )
}
export default AddItem
